export default __webpack_public_path__ + "static/media/config.1e56f940.svg";